import { gql } from '@apollo/client';

export const getShowPageMediaByIDsQuery = gql`
  query showPageMedias($sessionContext: SessionContext!, $ids: [String!]!) {
    medias(sessionContext: $sessionContext, ids: $ids) {
      title
      id
      mediaType
      shortDescription
      metadataImages {
        thumbnail {
          imageType
          url
          altText
        }
      }
      flags {
        detailedLabel
        label
        flag
      }
      originalLanguage {
        displayName
      }
      originatingNetworkLogo {
        imageType
        url
        altText
      }
      firstContent {
        id
        languageIndicators {
          indicator
          indicatorLabel
          languages {
            displayTitle
            langCode
            locked
          }
        }
        duration {
          timeLabel
        }
        seasonNumber
        episodeNumber
      }
      bookmark {
        ...ShowPageContentMetadataData
        seasonNumber
        episodeNumber
      }
      productionYear
      maturityRatings {
        id
        displayName
      }
      parentalControl {
        displaySubTitle
        displayTitle
        locked
      }
      isInWatchList
      genres {
        id
        displayName
      }
      badges {
        label
        detailedLabel
      }
      locked
      details {
        actions {
          displayLabel
          promo {
            id
          }
        }
        primarySponsorship {
          ...ShowPageLogoBarFragment
        }
        accessRack {
          showPrimaryCta
          primaryCtaLabel
          showSecondaryCta
          secondaryCtaLabel
          secondaryCtaAction
        }
      }
    }
  }
  fragment ShowPageLogoBarFragment on LogoBar {
    layoutType
    displayTitle
    logos {
      id
      image {
        url
        altText
      }
      __typename
    }
  }
  fragment ShowPageContentMetadataData on ContentMetadata {
    id
    title
    duration {
      timeInSecs
      timeLabel
      timeAccessibilityLabel
      progressPercentage
      remainingTimeInSecs
      remainingTimeLabel
      remainingTimeAccessibilityLabel
      lastModifiedTimestamp
    }
    media {
      id
    }
  }
`;

export const getMediaByIDsQuery = gql`
  query medias($sessionContext: SessionContext!, $ids: [String!]!) {
    medias(sessionContext: $sessionContext, ids: $ids) {
      title
      id
      mediaType
      shortDescription
      description
      metadataImages {
        poster {
          imageType
          url
          altText
        }
        thumbnail {
          imageType
          url
          altText
        }
      }
      flags {
        detailedLabel
        label
        flag
      }

      originalLanguage {
        displayName
      }

      originatingNetworkLogo {
        imageType
        url
        altText
      }

      firstContent {
        id
        languageIndicators {
          indicator
          indicatorLabel
          languages {
            displayTitle
            langCode
            locked
          }
        }
        duration {
          timeLabel
        }
        seasonNumber
        episodeNumber
      }

      bookmark {
        ...ContentMetadataData
        seasonNumber
        episodeNumber
      }

      productionYear
      maturityRatings {
        id
        displayName
      }
      parentalControl {
        displaySubTitle
        displayTitle
        locked
      }
      isInWatchList
      genres {
        id
        displayName
      }
      ratingWarnings {
        code
        displayLabelEn
        displayLabelFr
      }
      badges {
        label
        detailedLabel
      }
      locked
      seasons {
        title
        id
        seasonNumber
        episodesCount
      }
      details {
        actions {
          displayLabel
          actionType
          url
          promo {
            id
          }
        }
        tabs {
          id
          tabLabel
          tabType
          tabContents {
            ...MediaMetadataData
            ...ContentMetadataData
            ...ContainerData
          }
        }
        cast {
          role
          members {
            id
            displayName
          }
        }
        primarySponsorship {
          ...LogoBarFragment
        }
        secondarySponsorship {
          ...LogoBarFragment
        }
        socialBar {
          ...LogoBarFragment
        }
        metaDescriptor {
          id
          title
          description
          keywords
          images {
            url
            altText
            breakpoint
          }
        }
        accessRack {
          showPrimaryCta
          primaryCtaLabel
          showSecondaryCta
          secondaryCtaLabel
          secondaryCtaAction
        }
      }
    }
  }
  fragment LogoBarFragment on LogoBar {
    layoutType
    displayTitle
    logos {
      id
      image {
        url
        altText
      }
      __typename
    }
  }
  fragment MediaMetadataData on MediaMetadata {
    id
    title
  }
  fragment ContentMetadataData on ContentMetadata {
    id
    title
    duration {
      timeInSecs
      timeLabel
      timeAccessibilityLabel
      progressPercentage
      remainingTimeInSecs
      remainingTimeLabel
      remainingTimeAccessibilityLabel
      lastModifiedTimestamp
    }
    media {
      id
    }
  }
  fragment ContainerData on Container {
    id
    displayTitle
    style
    displayType
  }
`;
